import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras } from '@angular/router';

import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';

import { TransferStoreDet } from '../../../common/model/TransferStoreDet';
import { ExcelUtility } from '../../../common/util/ExcelUtility';
import { TransferStoreFacade } from '../../../common/facade/TransferStoreFacade';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';

@Component({
  selector: 'app-transfer-store-detail',
  templateUrl: './transfer-store-detail.component.html',
  styleUrls: ['./transfer-store-detail.component.css']
})
export class TransferStoreDetailComponent implements OnInit {
  titleTransfer = res.Transfer;
  lblDetailIngress = res.Detail;
  lblDownload = res.Download;
  lblOrigin = res.Origin;
  lblDestination = res.Destination;
  lblShippingNumber = res.ShippingNumber;
  lblGender = res.Gender;
  lblStyle = res.Style;
  lblSelectAnOption = res.SelectAnOption;
  lblSearch = res.Search;
  lblBrand = res.Brand;
  lblStyleVariety = res.StyleVariety;
  lblSize = res.Size;
  lblSent = res.Sent;
  lblEntry = res.Entry;

  isSpanish = true;
  language = 0

  messagesTable : any = {
    emptyMessage: "",
    totalMessage: "" 
  }

  loading = false;
  messageLoader = '';
  // alert
  alerts = [];
  // info Header
  storeOriginName = '';
  storeDestinyName = '';
  shippingNumber = '';
  // Filtros
  gender = '-1';
  genders = [];
  style = '-1';
  styles = [];

  rows: TransferStoreDet[] = [];
  private _filteredData: TransferStoreDet[] = [];

    transferReqId = '';
    private _organizationId: string;
    public extras: NavigationExtras;
    public path = '/transfer/store';
    private _storeOriginId = -1;
    private _storeDestinyId = -1;
    private _startDate: string;
    private _endDate: string;

  constructor(
    private _router: Router, 
    private _excel: ExcelUtility,
    private _transferStoreFacade: TransferStoreFacade,
    private _activatedRoute: ActivatedRoute,
    public strings: Strings,
    private localeService: BsLocaleService

  ) { }

  ngOnInit() {
     this.isSpanish = this.strings.getLanguageIsSpanish();
     this.localeService.use(this.strings.getLanguage());

    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

      this._activatedRoute.queryParams.subscribe(params => {
          this._storeOriginId = Number(params['storeOriginId']);
          this._storeDestinyId = Number(params['storeDestinyId']);
          this._startDate = params['startDate'];
          this._endDate = params['endDate'];
          this._organizationId = params['orgId'];

          this.extras = {
              queryParams: {
                'startDate': this._startDate
                , 'endDate': this._endDate
                , 'orgId': this._organizationId
                , 'storeOriginId': this._storeOriginId
                , 'storeDestinyId': this._storeDestinyId 
              }
          };
      });

    if (!this.isSpanish) {
      this.language = 1
    }

    this.getTransferStore();
  }

  private getTransferStore() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);
    const id = this._activatedRoute.snapshot.paramMap.get('id');
    this.transferReqId = id;
    this._transferStoreFacade.GetTransferStoreDetail(id).subscribe(
      response => {
        this.loading = false;
     
        this.rows = response.data.items;
        this._filteredData = response.data.items;
        this.gender = '-1';
        this.style = '-1';
        this.storeOriginName = response.data.storeOriginName;
        this.storeDestinyName = response.data.storeDestinationName;
        this.shippingNumber = response.data.referenceShippingType;
        this.fillSpinners();
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertTheTransfersCouldNotBeObtained), 'danger');
      }
    );
  }

  private fillSpinners() {
    this._filteredData.forEach(x => {
      if (!this.genders.includes(x.genderName)) {
        this.genders.push(x.genderName);
      }
      if (!this.styles.includes(x.style)) {
        this.styles.push(x.style);
      }
    });
  }

  // añadir alert
  addAlert(message: String, type: String) {
    this.alerts = [];
    this.alerts.push({
      type: type,
      msg: message
    });
  }

  // cerrar alert
  onClosed(dismissedAlert: AlertComponent) {
    this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
  }

  // Filtros
  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();
    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredData[0]);
    // assign filtered matches to the active datatable
    this.rows = this._filteredData.filter(function (item) {
      // iterate through each row's column data
      for (let i = 0; i < keys.length; i++) {
        if (item[keys[i]] != null && (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
          return true;
        }
      }
    });
  }

  onGenderChange() {
    this.style = '-1';
    if (this.gender.toString() === '-1') {
      this.rows = this._filteredData;
    } else {
      this.rows = this._filteredData.filter(item => {
        return (item.genderName.toString() === this.gender.toString());
      });
    }
  }

  onStyleChange() {
    this.gender = '-1';
    if (this.style.toString() === '-1') {
      this.rows = this._filteredData;
    } else {
      this.rows = this._filteredData.filter(item => {
        return (item.style.toString() === this.style.toString());
      });
    }
  }

  detailIngress(id) {
      this._router.navigate(['/transfer/store/entry/', id],
          { state: { origin: this.storeOriginName, destiny: this.storeDestinyName } } 
      );
  }
  // Save excel
  downloadLayout() {
    if (this.rows.length > 0) {
      const data: any = [];
      this.rows.forEach(row => {
        const info = {
          [this.strings.GetText(res.Brand)]: row.brandName,
          [this.strings.GetText(res.Gender)]: row.genderName,
          [this.strings.GetText(res.StyleVariety)]: row.styleVariety,
          [this.strings.GetText(res.Size)]: row.sizeName,
          [this.strings.GetText(res.Sent)]: row.quantity,
          [this.strings.GetText(res.Entry)]: row.quantityReceived
        };
        data.push(info);
      });
      this._excel.exportAsExcelFile(data, 'data');
    } else {
      this.addAlert(this.strings.GetText(res.AlertInfoMustBeLoadedToGenerateTheFile), 'danger');
    }
  }  
}
